<template>
    <div class="vx-row" id="formulation_table">

        <div class="vx-col w-full">
              <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="activities"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

                <template slot="thead">
                  <vs-th sort-key="contact_1">DATE/TIME</vs-th>
                  <vs-th sort-key="name">USER</vs-th>
                  <vs-th class="float-left">DESCRIPTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="tr.id || indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="tr.created_at || tr.updated_at">
                      {{ __dateTimeFormatter(tr.created_at || tr.updated_at) }}
                    </vs-td>
                    <vs-td :data="getCauser(tr)">
                      {{ getCauser(tr) }}
                    </vs-td>

                    <vs-td :data="getEventLabel(tr)">
                      <vs-chip transparent v-if="isCreatedEvent(tr)" color="primary">
                        {{ getEventLabel(tr) }}
                      </vs-chip>
                      <vs-chip transparent v-else-if="isUpdatedEvent(tr)" color="warning">
                        {{ getEventLabel(tr) }}
                      </vs-chip>
                      <vs-chip transparent v-else color="dark">
                        {{ getEventLabel(tr) }}
                      </vs-chip>
                    </vs-td>

                    <template class="expand-user" slot="expand">
                      <div class="con-expand-users w-full">

                          <div class="vx-row mb-4" v-if="checkActivityTypeIsItems(tr.properties)">
                            <div class="vx-col w-full p-8">
                              <vs-table class="w-full" :data="getItemList(tr.properties)">
                                <template slot="thead">
                                  <vs-th>ITEM / INGREDIENT NAME</vs-th>
                                  <vs-th>TYPE</vs-th>
                                  <vs-th>PREVIOUS QUANTITY (KG)</vs-th>
                                  <vs-th>NEW QUANTITY (KG)</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                  <vs-tr :key="idx" v-for="(row, idx) in data">
                                    <vs-td :data="row.name">{{ row.name }}</vs-td>
                                    <vs-td :data="row.type">
                                      <vs-chip transparent size="small" :color="row.type === 'Formulation Item' ? 'primary' : 'success'">
                                        {{ row.type }}
                                      </vs-chip>
                                    </vs-td>
                                    <vs-td :data="row.old_quantity">{{ row.old_quantity }}</vs-td>
                                    <vs-td :data="row.new_quantity">{{ row.new_quantity }}</vs-td>
                                  </vs-tr>
                                </template>
                              </vs-table>
                            </div>
                          </div>

                        <div class="vx-row" v-if="!hasOldValues(tr.properties) && getCreatedAttributes(tr.properties).length > 0">
                          <div class="vx-col w-full p-16">
                            <vs-table noDataText="" class="w-1/2" :data="getCreatedAttributes(tr.properties)">
                              <template slot="thead">
                                <vs-th>CHANGED FIELD</vs-th>
                                <vs-th>VALUE</vs-th>
                              </template>
                              <template slot-scope="{data}">
                                <vs-tr :key="idx" v-for="(row, idx) in data">
                                  <vs-td>{{ row.field }}</vs-td>
                                  <vs-td style="white-space: pre-wrap;">{{ row.value }}</vs-td>
                                </vs-tr>
                              </template>
                            </vs-table>
                          </div>
                        </div>

                          <div class="vx-row" v-else-if="hasOldValues(tr.properties) && getChangedFieldList(tr.properties).length > 0">
                            <div class="vx-col w-full p-16">
                              <vs-table noDataText="" class="w-full" :data="getChangedFieldList(tr.properties)">
                                <template slot="thead">
                                  <vs-th>CHANGED FIELD</vs-th>
                                  <vs-th>PREVIOUS VALUE</vs-th>
                                  <vs-th>NEW VALUE</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                  <vs-tr :key="idx" v-for="(row, idx) in data">
                                    <vs-td>{{ row.field }}</vs-td>
                                    <vs-td style="white-space: pre-wrap;">{{ row.oldValue }}</vs-td>
                                    <vs-td style="white-space: pre-wrap;">{{ row.newValue }}</vs-td>
                                  </vs-tr>
                                </template>
                              </vs-table>
                            </div>
                          </div>

                      </div>
                    </template>

                  </vs-tr>
                </template>


              </vs-table>
              <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

            </div>
        </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const FormulationsRepository = RepositoryFactory.get('formulations')

  export default {
      name: "FormulationGeneral",
      components: {
      },
      data () {
        return {
          formulationId: '',
          activities: [],
          page : 1,
          total: 0,
          meta : {},
        }
      },
      methods: {
        async loadFormulationsActivityLog() {
          await this.$vs.loading({
            container: '#formulation_table',
            scale: 0.45
          })
          try {
            const {data} = (await FormulationsRepository.getStaffFormulationLogs(this.formulationId, this.page, 10))
            this.activities = data.data || []
            this.meta = data.meta || {}
          } catch (error) {
            console.error('Failed to load new formulation logs, falling back to legacy endpoint:', error)
            try {
              const {data} = (await FormulationsRepository.getActivityLog(this.formulationId, this.page, 10))
              this.activities = data.data || []
              this.meta = data.meta || {}
            } catch (fallbackError) {
              console.error('Failed to load formulation logs:', fallbackError)
            }
          } finally {
            this.$vs.loading.close('#formulation_table > .con-vs-loading')
          }
        },
        handleChangePage(page) {
          this.page = page;
          this.loadFormulationsActivityLog()
        },
        getCauser(tr) {
          if (!tr) return '-';
          if (tr.causer && tr.causer.name) return tr.causer.name;
          return tr.causer_name || '-';
        },
        getEventLabel(tr) {
          if (!tr) return '';
          return tr.event || tr.description || 'Activity';
        },
        isCreatedEvent(tr) {
          if (!tr) return false;
          if (tr.description === 'created') return true;
          if (tr.event && typeof tr.event === 'string' && tr.event.toLowerCase().includes('creat')) return true;
          return false;
        },
        isUpdatedEvent(tr) {
          if (!tr) return false;
          if (tr.description === 'updated') return true;
          if (tr.event && typeof tr.event === 'string' && tr.event.toLowerCase().includes('updat')) return true;
          return false;
        },
        checkActivityTypeIsItems(properties) {
          if (!properties) return false;
          if (Array.isArray(properties)) return true;
          const hasRms = Boolean(
            (properties.new && Array.isArray(properties.new.raw_material_items) && properties.new.raw_material_items.filter(Boolean).length > 0) ||
            (properties.old && Array.isArray(properties.old.raw_material_items) && properties.old.raw_material_items.filter(Boolean).length > 0) ||
            (properties.attributes && Array.isArray(properties.attributes.raw_material_items) && properties.attributes.raw_material_items.filter(Boolean).length > 0)
          );
          const hasFis = Boolean(
            (properties.new && Array.isArray(properties.new.formulation_items) && properties.new.formulation_items.filter(Boolean).length > 0) ||
            (properties.old && Array.isArray(properties.old.formulation_items) && properties.old.formulation_items.filter(Boolean).length > 0) ||
            (properties.attributes && Array.isArray(properties.attributes.formulation_items) && properties.attributes.formulation_items.filter(Boolean).length > 0)
          );
          return hasRms || hasFis;
        },
        checkActivityTypeIsRawMaterial(properties) {
          return this.checkActivityTypeIsItems(properties);
        },
        getItemList(properties) {
          if (!properties) return [];
          if (Array.isArray(properties)) {
            return properties.filter(Boolean).map(item => ({
              name: item.name || item.log_label,
              type: 'Raw Material',
              old_quantity: item.old_quantity !== undefined && item.old_quantity !== null ? item.old_quantity : '-',
              new_quantity: item.attribute_quantity || item.new_quantity || item.quantity || '-'
            }));
          }

          const pairGroup = (newArr, oldArr, type) => {
            const newFiltered = (newArr || []).filter(Boolean);
            const oldFiltered = (oldArr || []).filter(Boolean);

            const oldMap = new Map();
            oldFiltered.forEach(item => {
              const key = item.formulation_code || item.unique_code || item.name || item.log_label;
              if (key) oldMap.set(key, item);
            });

            const rows = [];
            const processedOldKeys = new Set();

            newFiltered.forEach(newItem => {
              const key = newItem.formulation_code || newItem.unique_code || newItem.name || newItem.log_label;
              const oldItem = key ? oldMap.get(key) : null;
              if (key && oldItem) processedOldKeys.add(key);

              let displayName = newItem.name || newItem.log_label || newItem.formulation_code;
              if (newItem.formulation_code && newItem.name && newItem.name !== newItem.formulation_code) {
                displayName = `${newItem.formulation_code} - ${newItem.name}`;
              }

              rows.push({
                name: displayName,
                type: type,
                old_quantity: (oldItem && oldItem.quantity !== undefined && oldItem.quantity !== null) ? oldItem.quantity : '-',
                new_quantity: (newItem.quantity !== undefined && newItem.quantity !== null) ? newItem.quantity : '-'
              });
            });

            oldFiltered.forEach(oldItem => {
              const key = oldItem.formulation_code || oldItem.unique_code || oldItem.name || oldItem.log_label;
              if (key && !processedOldKeys.has(key)) {
                let displayName = oldItem.name || oldItem.log_label || oldItem.formulation_code;
                if (oldItem.formulation_code && oldItem.name && oldItem.name !== oldItem.formulation_code) {
                  displayName = `${oldItem.formulation_code} - ${oldItem.name}`;
                }
                rows.push({
                  name: displayName,
                  type: type,
                  old_quantity: (oldItem.quantity !== undefined && oldItem.quantity !== null) ? oldItem.quantity : '-',
                  new_quantity: '-'
                });
              }
            });

            return rows;
          };

          const newProp = properties.new || properties.attributes || {};
          const oldProp = properties.old || {};

          const rawMaterialRows = pairGroup(
            newProp.raw_material_items,
            oldProp.raw_material_items,
            'Raw Material'
          );

          const formulationItemRows = pairGroup(
            newProp.formulation_items,
            oldProp.formulation_items,
            'Formulation Item'
          );

          return [...rawMaterialRows, ...formulationItemRows];
        },
        getRawMaterialList(properties) {
          return this.getItemList(properties);
        },
        hasOldValues(properties) {
          if (!properties || !properties.old) return false;
          if (Array.isArray(properties.old)) {
            return properties.old.filter(Boolean).length > 0;
          }
          if (typeof properties.old === 'object') {
            const nonItemKeys = Object.keys(properties.old).filter(
              key => key !== 'raw_material_items' && key !== 'formulation_items'
            );
            return nonItemKeys.some(k => {
              const val = properties.old[k];
              if (val === null || val === undefined) return false;
              if (Array.isArray(val)) return val.filter(Boolean).length > 0;
              if (typeof val === 'object') return Object.keys(val).length > 0;
              return true;
            });
          }
          return false;
        },
        getCreatedAttributes(properties) {
          if (!properties) return [];
          const attrs = properties.new || properties.attributes || {};
          return Object.entries(attrs)
            .filter(([key]) => key !== 'raw_material_items' && key !== 'formulation_items')
            .map(([key, val]) => ({
              field: this.underScoreRemove(key),
              value: (val !== null && val !== undefined) ? (typeof val === 'object' ? JSON.stringify(val) : val) : '-'
            }));
        },
        getChangedFieldList(properties) {
          if (!properties) return [];
          const oldVals = (properties.old && typeof properties.old === 'object' && !Array.isArray(properties.old))
            ? properties.old
            : {};
          const newVals = (properties.new || properties.attributes) && typeof (properties.new || properties.attributes) === 'object'
            ? (properties.new || properties.attributes)
            : {};

          const allKeys = Array.from(new Set([...Object.keys(oldVals), ...Object.keys(newVals)]))
            .filter(key => key !== 'raw_material_items' && key !== 'formulation_items');

          return allKeys.map(key => ({
            field: this.underScoreRemove(key),
            oldValue: (oldVals[key] !== null && oldVals[key] !== undefined)
              ? (typeof oldVals[key] === 'object' ? JSON.stringify(oldVals[key]) : oldVals[key])
              : '-',
            newValue: (newVals[key] !== null && newVals[key] !== undefined)
              ? (typeof newVals[key] === 'object' ? JSON.stringify(newVals[key]) : newVals[key])
              : '-'
          }));
        },
        underScoreRemove(string) {
          if (!string || typeof string !== 'string') return string;
          return string.replaceAll("_", " ");
        }
      },
      async mounted() {
        this.formulationId = this.$route.params.id
        await this.loadFormulationsActivityLog()
      },
      mixins: [SuccessMessage, ErrorMessages],
      watch : {
        page(){
          this.loadFormulationsActivityLog()
        }
      }
    }
</script>

<style scoped>

  .__table-heading-small{
    font-size: x-small;
    font-weight: normal;
  }

</style>
